<template>
  <!-- 首页-数据看板-国内申请人排名-堆积柱状图 -->
	<div ref="echartBar" :style="{margin: '0 auto',width: '100%', height: '100%'}"></div>
</template>

<script>
	export default {
		data() {
			return {

			}
		},
		props: {
			echartDatas: {
				type: Array,
				default() {
					return []
				}
			},
			barColor: {
				type: String,
				default() {
					return ''
				}
			}
		},
		components: {
		},
		created() {
		},
		mounted() {
			this.drawChart()
		},
		methods: {
			drawChart() {
        let echartDatas = this.echartDatas
        let yAxisDatas = []
        let seriesDatas1 = [] // 未授权
        let seriesDatas2 = [] // 有效
        let seriesDatas3 = [] // 失效
        let seriesDatas4 = [] // 数量-总数
        for (let i = echartDatas.length - 1; i >= 0; i--) {
          if (echartDatas[i].name.length > 16) {
            let namestr = echartDatas[i].name.substring(0, 16)
            yAxisDatas.push(namestr + '……')
          } else {
            yAxisDatas.push(echartDatas[i].name)
          }
          seriesDatas1.push(echartDatas[i].ls1)
          seriesDatas2.push(echartDatas[i].ls2)
          seriesDatas3.push(echartDatas[i].ls3)
          seriesDatas4.push(echartDatas[i].count)
        }
        // "name": "华为技术有限公司",
        // "count": 1591, //数量
        // "remark": "",
        // "ls2": 844, //有效
        // "id": "4884459490529954612",
        // "ls1": 110, //未授权
        // "ls3": 637 //已失效
				// this.$refs.echartBar.removeAttribute("_echarts_instance_");
				// document.getElementById('echartLine').removeAttribute("_echarts_instance_");
				// 基于准备好的dom，初始化echarts实例
				let myChart = this.$echarts.init(this.$refs.echartBar, 'light')
				let barDatas = this.echartDatas
        let barColor = 'rgba(5, 1, 98, 0.6)'
        if (this.barColor) {
          barColor = this.barColor
        }
				// 指定图表的配置项和数据
				let option = {
					title: {
            text: "包头市申请人排名",
            x: "center",
            y: 0,
            textStyle: {
              fontSize: 18,
              fontWeight: "normal",
              color: "#ffffff"
            }
          },
          legend: {
            bottom: "0",
            // right: '5',
            data: [
              {
                name: "未授权",
                textStyle: {
                  color: "#ffffff",
                  fontStyle: "normal",
                  fontWeight: "normal",
                  // fontFamily: 'sans-serif',
                  fontSize: 14
                }
              },
              {
                name: "有效",
                textStyle: {
                  color: "#ffffff",
                  fontStyle: "normal",
                  fontWeight: "normal",
                  // fontFamily: 'sans-serif',
                  fontSize: 14
                }
              },
              {
                name: "已失效",
                textStyle: {
                  color: "#ffffff",
                  fontStyle: "normal",
                  fontWeight: "normal",
                  // fontFamily: 'sans-serif',
                  fontSize: 14
                }
              }
            ]
          },
          grid: {
            top: "8%",
            left: "3%",
            right: "8%",
            bottom: "6%",
            containLabel: true
          },
          xAxis: {
            show: true,
            type: "value",
            axisLabel: {
              show: false,
              textStyle: {
                fontSize: 14,
                fontWeight: "bolder",
                color: "#ffffff"
              }
            },
            splitNumber: 5,
            splitLine: {
              lineStyle: {
                type: "dashed",
                color: "#D9D9D9",
                width: 0.4
              }
            }
          },
          yAxis: {
            type: "category",
            data: yAxisDatas,
            // data: [
            //   '腾讯科技(深圳)有限公司',
            //   '平安科技(深圳)有限公司'
            // ],
            // min: 2,
            axisLabel: {
              formatter: function(params) {
                return params.length > 16 ? params.slice(0, 16) + '...' : params
              },
              textStyle: {
                color: "#ffffff",
                fontStyle: "normal",
                fontWeight: "normal",
                // fontFamily: 'sans-serif',
                fontSize: 14
              }
            }
          },
          series: [
            {
              name: "未授权",
              type: "bar",
              stack: "total",
              color: "#5470c6",
              label: {
                // show: true,
                position: "insideLeft",
                textStyle: {
                  color: "#FFFFFF",
                  fontStyle: "normal",
                  fontWeight: "normal",
                  // fontFamily: 'sans-serif',
                  fontSize: 14
                }
              },
              data: seriesDatas1,
              // data: [220, 324, 326, 102, 349, 325, 140, 410, 444, 369, 557, 471, 382, 413, 646, 779, 468, 706, 1387, 878],
              barWidth: "12"
            },
            {
              name: "有效",
              type: "bar",
              stack: "total",
              color: "#3ba272",
              label: {
                // show: false,
                position: "insideLeft",
                textStyle: {
                  color: "#FFFFFF",
                  fontStyle: "normal",
                  fontWeight: "normal",
                  // fontFamily: 'sans-serif',
                  fontSize: 14
                }
              },
              data: seriesDatas2
              // data: [76, 0, 0, 209, 4, 46, 250, 24, 2, 86, 3, 87, 154, 212, 51, 103, 422, 509, 154, 819]
            },
            {
              name: "已失效",
              color: "#ee6666",
              type: "bar",
              stack: "total",
              label: {
                // show: false,
                position: "insideLeft",
                textStyle: {
                  color: "#FFFFFF",
                  fontStyle: "normal",
                  fontWeight: "normal",
                  fontFamily: "sans-serif",
                  fontSize: 14
                }
              },
              data: seriesDatas3
              // data: [7, 0, 0, 15, 0, 16, 0, 11, 0, 38, 0, 13, 50, 45, 2, 6, 67, 57, 13, 8]
            },
            {
              name: "申请量",
              type: "bar",
              stack: "",
              barGap: "-40%",
              z: -1,
              label: {
                show: true,
                position: "right",
                formatter: "{c}",
                textStyle: { color: "#FFD700" }
              },
              itemStyle: {
                normal: {
                  color: "#0A183F"
                }
              },
              data: seriesDatas4
              // data: [303, 324, 326, 326, 353, 387, 390, 445, 446, 493, 560, 571, 586, 670, 699, 888, 957, 1272, 1554, 1705]
            }
          ]
				}
				// 使用刚指定的配置项和数据显示图表。
				myChart.setOption(option)
			}
		},
		watch: {
			echartDatas: {
				handler() { // val, oldVal
					// console.log('当数量变化时重新绘制图表')//但是这两个值打印出来却都是一样的
					this.drawChart()
				}
			}
		}
	}
</script>

<style>
</style>
